import { FC } from 'react';
import { CatButton } from '@blocks-react/components/Button';
import { OrderStatusProps } from '../types';
import styles from '../NotificationDrawer.module.scss';

export const OrderStatus: FC<OrderStatusProps> = ({
  children,
  handleOpen,
  orderDisplayLinkText,
  CONTACT_DEALER_CARDS,
  reviewLink,
  link
}) => {
  return (
    orderDisplayLinkText && (
      <div
        data-testid="content-notification"
        className={`${styles['order-status']}`}
      >
        {CONTACT_DEALER_CARDS ? (
          <>
            <CatButton
              onClick={handleOpen}
              className={`${styles['order-status_order-display-link']} d-flex`}
              data-testid="contact-dealer-btn"
              variant="danger"
            >
              {orderDisplayLinkText}
            </CatButton>
            {children}
          </>
        ) : (
          <CatButton
            href={reviewLink || link}
            className={`${styles['order-status_order-display-link']} d-flex `}
            data-testid="order-display-link"
          >
            {orderDisplayLinkText}
          </CatButton>
        )}
      </div>
    )
  );
};
